import { DomainSwitch } from "_components/Abstractions/DomainSwitch";
import { TextArea } from "_components/Forms/TextArea";
import { Card, Col, Container, Row } from "react-bootstrap";
import { ContactPersonsForm } from "./ContactPersonsForm";
import { FormControl } from "_components/Forms/FormControl";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { UsedContainersForm } from "./UsedContainersForm";
import { BdoAddressForm } from "./BdoAddressForm";
import { WastesMultiSelect } from "./WastesMultiSelect";
import { ServicesMultiSelect } from "./ServicesMultiSelect";
import { CONTRACTOR_TYPES } from "../../../../domain/ContractorType";

export function AddressForm({ addressField, isCentral, isUpdate }) {
  const GetFullField = (field) => `${addressField}.${field}`;
  const { setValue, watch } = useFormContext();
  const isExisting = watch(GetFullField("isExisting"));
  const isPickup = watch(GetFullField("isPickup"));
  const isDefault = watch(GetFullField("isDefault"));
  const isActive = watch(GetFullField("isActive"));
  const contractorTypes = watch("contractorTypes");
  const isSenderContractorType = contractorTypes?.includes(CONTRACTOR_TYPES.SENDER);
  const isReceiverContractorType = contractorTypes?.includes(CONTRACTOR_TYPES.RECEIVER);
  const defaultFieldAddressName = watch("defaultFieldAddressName");
  // const { replace: replaceUsedContainers } = useFieldArray({ name: GetFullField("usedContainers") });

  useEffect(() => {
    if (isCentral) {
      setValue(`${addressField}.isCentral`, true);
      if (!isPickup) {
        setValue(`${addressField}.isPickup`, false);
      }
      if (isDefault === true) {
        setValue("defaultFieldAddressName", addressField);
      }
      if (!isDefault) {
        setValue(`${addressField}.isDefault`, false);
      }

      setValue(`${addressField}.isActive`, true);
    }
  }, []); // eslint-disable-next-line/react-hooks/exhaustive-deps

  useEffect(() => {
    if (isDefault === true) {
      setValue("defaultFieldAddressName", addressField);
    }
  }, [isDefault]);

  useEffect(() => {
    if (isDefault === false) {
      return;
    }

    if (isDefault === true && defaultFieldAddressName !== addressField && defaultFieldAddressName) {
      setValue(`${addressField}.isDefault`, false);
    }
  }, [defaultFieldAddressName, isPickup]);

  useEffect(() => {
    if (isPickup === false) {
      setValue(`${addressField}.isDefault`, false);
    }
  }, [isPickup]);

  useEffect(() => {
    if (isActive === false && isDefault === true) {
      setValue(`${addressField}.isDefault`, false);
      // replaceUsedContainers([]);
    }
  }, [isActive]);

  return (
    <Container className={`${!isCentral ? "form-control" : ""}`}>
      <Row>
        <Col>
          {isCentral && (
            <DomainSwitch
              label="Adres centrali jest adresem dostawy"
              name={GetFullField("isPickup")}
            />
          )}
          {isPickup && (
            <>
              <Card.Header as="h6">
                Dane BDO (Miejsce prowadzenia działalności gospodarczej)
              </Card.Header>
              <BdoAddressForm addressField={addressField}/>
            </>
          )}
          <Card.Header as="h6">Dane adresowe</Card.Header>
          <FormControl label="Nazwa adresu" name={GetFullField("name")}/>
          <Row>
            <Col>
              <FormControl
                label="Kod pocztowy"
                name={GetFullField("postalCode")}
              />
            </Col>
            <Col>
              <FormControl label="Miasto" name={GetFullField("city")}/>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <FormControl label="Ulica" name={GetFullField("streetName")}/>
            </Col>
            <Col>
              <FormControl label="Numer" name={GetFullField("streetNumber")}/>
            </Col>
            <Col>
              <FormControl label="Lokal" name={GetFullField("apartment")} required={false}/>
            </Col>
          </Row>
          <TextArea label="Uwagi do adresu" name={GetFullField("remarks")}/>
          <div className="d-flex gap-3">
          {<DomainSwitch label="Aktywny" name={GetFullField("isActive")} readonly={isCentral || !isUpdate || !isExisting}/> }
          {isPickup && (
            <DomainSwitch label="Domyślny adres dostawy" name={GetFullField("isDefault")}/>
          )}
          </div>
        </Col>
        <Col>
          <Card.Header as="h6">Osoby kontakowe do adresu</Card.Header>
          <ContactPersonsForm prefix={`${addressField}`} isAddressContact/>
          {isSenderContractorType && (
            <>
              <Card.Header className="mt-3" as="h6">Usługi zakupowe</Card.Header>
              <Card.Body>
                <ServicesMultiSelect name={`${addressField}.purchaseServicesIds`} editHelperName="purchaseServices" skipInitLoading required={false}/>
              </Card.Body>
            </>
          )}
          {isReceiverContractorType && (
            <>
              <Card.Header className="mt-3" as="h6">Usługi sprzedażowe</Card.Header>
              <Card.Body>
                <ServicesMultiSelect name={`${addressField}.saleServicesIds`} editHelperName="saleServices" skipInitLoading required={false}/>
              </Card.Body>
            </>
          )}
          {isPickup && (
            <>
              <Card.Header className="mt-3" as="h6">Załadunek</Card.Header>
              <Card.Body>
                <WastesMultiSelect name={`${addressField}.loadingWastesIds`} wastesEditHelperNameType="wastes" skipInitLoading required={false}/>
              </Card.Body>
              {isReceiverContractorType && <>
                <Card.Header className="mt-3" as="h6">Sprzedaż</Card.Header>
                <Card.Body>
                  <WastesMultiSelect name={`${addressField}.saleWastesIds`} wastesEditHelperNameType="saleWastes" skipInitLoading required={false}/>
                </Card.Body>
              </>}
              <Card.Header as="h6">Kontenery</Card.Header>
              <UsedContainersForm prefix={`${addressField}`} isAddressActive={isActive}/>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
}
